import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setSingleDocument, setLoading } from "../../repository/slice";

function* getSingleDocumentWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/document/get/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleDocument(data));
        }
    } catch (error) {
        console.error("getSingleDocumentWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleDocumentWatcher() {
    yield takeLatest("@saga/GET_SINGLE_DOCUMENT", getSingleDocumentWorker);
};
